document.addEventListener("DOMContentLoaded", async function () {
  const dialog = document.querySelector(".popup-notif-container");
  const closeBtns = document.querySelectorAll(".popup-notif-close-btn");
  const number_inp_ctnr = document.querySelector(".popup-notif-input");
  const number_inp = document.querySelector(".popup-notif-input input");
  const input_wrapper = document.querySelector(".popup-notif-wrapper");
  const done_wrapper = document.querySelector(".popup-notif-done");
  const number_submit = document.querySelector(".popup-notif-btn");
  const notif_btn = document.querySelector(".add-to-cart-notify");
  const hint = document.querySelector(".popup-notif-hint");

  number_inp.addEventListener('keypress', onEnter);
  number_submit.addEventListener("click", submitContactForm);
  notif_btn.addEventListener("click", showPopupnotifElem);
  closeBtns.forEach((btn) => btn.addEventListener("click", closenotifPopup));
  const numberVerify = /^\d{10}$/;
  // setTimeout(showPopupnotifElem, 1000); // Show Popup for notif after 10s of Document load event.
  
  function showPopupnotifElem() {
    // selecting the sku. notification saperate for each chair varient
    var selectedVariantSku = getSku();
    if(localStorage.getItem(selectedVariantSku) !== "collected"){
      resetForm();
      console.log("reset")
    }else{
      completedForm();
      console.log("completed")
    }
    dialog.showModal();
  }

  function getSku(){
    var selectedSwatch = document.querySelector(
      ".product-landing-section .color-container .color-swatch.selected"
    );
    var selectedVariantSku;
    // saperate logic for chair and desk
    if(!selectedSwatch){
      var priceContainer = document.querySelector(
      ".product-landing-section.desk .price-container.active");
      selectedVariantSku = priceContainer.dataset.variantSku
    }else{
      var selectedSwatchParentColorContainer = selectedSwatch.parentElement;
      selectedVariantSku = selectedSwatchParentColorContainer.dataset.variantSku;  
    }
    return selectedVariantSku;
  }

  function resetForm(){
    input_wrapper.style.display = "flex";
    done_wrapper.style.display = "none";
    hint.style.color = "transparent";
    number_inp_ctnr.style.borderColor = "#393939";
  }

  function completedForm(){
    input_wrapper.style.display = "none";
    done_wrapper.style.display = "flex";
  }

  function onEnter(e){
    if(e.key === 'Enter')submitContactForm(e)
  }

  function closenotifPopup() {
    dialog.close();
    openCheck(dialog);
  }

  function openCheck(dialog) {
    if (dialog.open) {
      console.log("Pop up open");
    } else {
      console.log("Pop up closed");
    }
  }

  async function submitContactForm(e) {
    e.preventDefault();

    if (numberVerify.test(number_inp.value)) {
      // selecting sku
      var selectedVariantSku = getSku();

      // payload
      const options = {
        method: 'POST',
        headers: {
          'content-type': 'application/json-patch+json',
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3MTFlYTM2Ni1iMzU0LTQ2NjYtOGRjYS0xYjg4OTg5OTc5NGMiLCJ1bmlxdWVfbmFtZSI6ImNhcmVAc3VwZXJlcmdvLmluIiwibmFtZWlkIjoiY2FyZUBzdXBlcmVyZ28uaW4iLCJlbWFpbCI6ImNhcmVAc3VwZXJlcmdvLmluIiwiYXV0aF90aW1lIjoiMTIvMzEvMjAyNCAwNzoxODo1MyIsInRlbmFudF9pZCI6IjM4NzEyMiIsImRiX25hbWUiOiJtdC1wcm9kLVRlbmFudHMiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJBRE1JTklTVFJBVE9SIiwiZXhwIjoyNTM0MDIzMDA4MDAsImlzcyI6IkNsYXJlX0FJIiwiYXVkIjoiQ2xhcmVfQUkifQ.lIzxjuSHBy7-vO3z70YIs4kzDE6dJTtttweKVNCQA9s'
        },
        body: JSON.stringify({
          "name": "",
          "customParams": [
            {
              "name": selectedVariantSku,
              "value": "TRUE"
            },
            {
              "name": "notify_me",
              "value": "TRUE"
            },
            {
              "name": "sold_out",
              "value": "TRUE"
            }
          ]
        })
      };

      fetch(`https://live-mt-server.wati.io/387122/api/v1/addContact/${"91"+number_inp.value}`, options)
        .then(res => res.json())
        .then(res => console.log(res))
        .catch(err => console.error(err));
      
      input_wrapper.style.display = "none";
      done_wrapper.style.display = "flex";
      localStorage.setItem(selectedVariantSku, "collected");
    } else {
      hint.style.color = "#EF4D22";
      number_inp_ctnr.style.borderColor = "#EF4D22";
    }
  }
});
